import { render, staticRenderFns } from "./CmgMealCard.vue?vue&type=template&id=74811fb0&scoped=true&lang=pug"
import script from "./cmg-meal-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealCard.vue?vue&type=style&index=0&id=74811fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74811fb0",
  null
  
)

export default component.exports